export const dataFlip =  {
    "attrs": {
        "profile_id": "52295",
        "profile_url": "/people/Sierra-Stangel/52295",
        "name": "Sierra Hope STANGEL",
        "long_name": "Sierra Hope STANGEL",
        "first_name": "Sierra",
        "birth": "January 23, 2009",
        "about_me_summary": "GEDCOM Note ==={geni:about_me} Give me a smile and I'll give you a bigger one right back!",
        "last_updated_info": "\u003Ca href=\"/people/James-Ming/13038\" class=\"linkTertiary\" data-profile-id=\"13038\" draggable=\"false\" pid=\"13038\"\u003EJames Joseph MING\u003C/a\u003E on February 13, 2018",
        "added_info": "\u003Ca href=\"/people/James-Ming/13038\" class=\"linkTertiary\" data-profile-id=\"13038\" draggable=\"false\" pid=\"13038\"\u003EJames Joseph MING\u003C/a\u003E on February 13, 2018",
        "manager_info": "\u003Ca href=\"/people/James-Ming/13038\" bypass_newsfeed_helper=\"true\" class=\"tipped-tip\" data-offset-x=\"-10\" data-offset-y=\"-10\" data-position=\"topleft\" data-profile-id=\"13038\" data-remote-data=\"/profile/hovercard\" data-remote-params=\"{id:13038}\" data-show-delay=\"800\" data-skin=\"hovercard\" data-template=\"hover.profile\" draggable=\"false\"\u003EJames Joseph MING (旭)\u003C/a\u003E",
        "mugshot_img_t2": "\u003Cimg alt=\"\" src=\"http://192.168.56.102:5000/images/photo_silhouette_f_thumb2.gif\" style=\" border:2px solid transparent;-moz-border-image: -moz-linear-gradient(top left, #cccccc 0%, #ffffff 100%);-webkit-border-image: -webkit-linear-gradient(top left, #cccccc 0%, #ffffff 100%);border-image: linear-gradient(to bottom right, #cccccc 0%, #ffffff 100%);border-image-slice: 1;\" /\u003E"
    },
    "display": {
        "profile": true,
        "birth": true,
        "death": false,
        "location": false,
        "occupation": false,
        "dna_markers": false,
        "nearby_tree_matches": false,
        "private_profile": false,
        "about": true,
        "last_updated": true,
        "added_info": true,
        "joined_info": false,
        "manager_info": true,
        "curator_info": false,
        "action_profile": true,
        "action_tree": true,
        "action_edit": true,
        "action_add": true,
        "action_more": true,
        "action_delete": true,
        "action_move": true,
        "action_resolve_conflicts": false,
        "action_resize_photo": false,
        "action_add_photo": true,
        "action_remove_photo": false,
        "action_add_sources": true,
        "action_add_to_project": false,
        "action_resolve_duplicates": true,
        "action_follow": true,
        "action_unfollow": false,
        "action_curator_options": false,
        "action_remove_family": false,
        "action_add_family": false,
        "action_remove_collaborator": false,
        "action_add_collaborator": false,
        "action_send_message": false
    },
    "immediate_family": {
        "tree": {
            "unions": [
                {
                    "u": 3753,
                    "t": "c",
                    "m": "932284",
                    "p": [
                        3755
                    ],
                    "c": [
                        3752
                    ]
                },
                {
                    "u": 3754,
                    "t": "c",
                    "m": "52705",
                    "p": [
                        3756,
                        3757
                    ],
                    "c": [
                        3758,
                        3759,
                        3752
                    ]
                },
                {
                    "u": 3760,
                    "t": "c",
                    "m": "52707",
                    "c": [
                        3756
                    ]
                },
                {
                    "u": 3761,
                    "t": "c",
                    "m": "52709",
                    "c": [
                        3757
                    ]
                },
                {
                    "u": 3762,
                    "t": "c",
                    "m": "93581",
                    "c": [
                        3757
                    ]
                },
                {
                    "u": 3763,
                    "t": "c",
                    "m": "52710",
                    "c": [
                        3757
                    ]
                }
            ],
            "nodes": [
                {
                    "n": 3752,
                    "pid": "40003822",
                    "pr_id": "52295",
                    "d_t": 1,
                    "npu": "2",
                    "d_r": 1,
                    "l": 1,
                    "g": "f",
                    "dob_y": "2009",
                    "nn": "3821",
                    "app": 1,
                    "tm": "0",
                    "fn": "Sierra",
                    "mn": "Hope",
                    "ln": "Stangel",
                    "nm": "Sierra Hope STANGEL",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "g_e": "1",
                    "focus": 1
                },
                {
                    "n": 3755,
                    "pid": "40131124",
                    "pr_id": "932281",
                    "d_r": 1,
                    "lf": 1,
                    "l": 1,
                    "g": "m",
                    "nn": "131195",
                    "app": 1,
                    "tm": "0",
                    "fn": "Other Father",
                    "ln": "Stangel",
                    "nm": "Other Father STANGEL",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "g_e": "1"
                },
                {
                    "n": 3756,
                    "pid": "40003817",
                    "pr_id": "52003",
                    "d_r": 1,
                    "b_o": "1",
                    "p_o": "3757",
                    "l": 1,
                    "g": "m",
                    "dob_y": "1971",
                    "nn": "3816",
                    "app": 1,
                    "tm": "0",
                    "fn": "Mike",
                    "mn": "Alan",
                    "ln": "Stangel",
                    "nm": "Mike Alan STANGEL",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "dc": 1,
                    "g_e": "1"
                },
                {
                    "n": 3757,
                    "pid": "40003819",
                    "pr_id": "52279",
                    "npu": "3",
                    "ptc": 1,
                    "d_r": 1,
                    "p_o": "3756",
                    "l": 1,
                    "g": "f",
                    "dob_y": "1970",
                    "nn": "3818",
                    "app": 1,
                    "tm": "0",
                    "fn": "Dana",
                    "mn": "Lynn",
                    "ln": "Dienes",
                    "nm": "Dana Lynn DIENES",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "g_e": "1"
                },
                {
                    "n": 3758,
                    "pid": "40003820",
                    "pr_id": "52284",
                    "lf": 1,
                    "l": 1,
                    "g": "m",
                    "dob_y": "2002",
                    "nn": "3819",
                    "app": 1,
                    "tm": "0",
                    "fn": "Jack",
                    "mn": "Andrew",
                    "ln": "Stangel",
                    "nm": "Jack Andrew STANGEL",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "g_e": "1"
                },
                {
                    "n": 3759,
                    "pid": "40003821",
                    "pr_id": "52289",
                    "lf": 1,
                    "l": 1,
                    "g": "m",
                    "dob_y": "2006",
                    "nn": "3820",
                    "app": 1,
                    "tm": "0",
                    "fn": "Ethan",
                    "mn": "Michael",
                    "ln": "Stangel",
                    "nm": "Ethan Michael STANGEL",
                    "tag": 1,
                    "del": 1,
                    "a": 1,
                    "e": 1,
                    "g_e": "1"
                }
            ],
            "metadata": {
                "infos": {
                    "max_ancestor_gen": "1",
                    "max_descendant_gen": "0"
                }
            }
        }
    }
}
